import { n as e, r as t, t as n } from "./service.types-CDefnrwA.js";
import { useWebSocket as r } from "@vueuse/core";
import { ref as i, watch as a } from "vue";
//#region src/composables/useEventService.ts
var o = {}, s = (e, t) => `wss://${e === n.Event ? "event" : `event.${String(e).toLowerCase()}`}.${t === "acceptance" ? "api.acceptance" : "api"}.myparcel.nl`, c = (e) => {
	if (!e.accessToken) throw Error("No accessToken provided.");
	let t = new URLSearchParams();
	t.append("accessToken", e.accessToken), "shopIds" in e && e.shopIds.forEach((e) => {
		t.append("shopIds", e);
	});
	let n = t.toString();
	if (!o[e.serviceName] || o[e.serviceName].filter !== n) {
		let c = s(e.serviceName, e.environment), l = {};
		e.autoReconnect !== !1 && (l.autoReconnect = {
			retries: 10,
			delay: 3e3
		}), e.heartBeat !== !1 && (l.heartbeat = {
			message: "/ping",
			interval: 1e4,
			pongTimeout: 5e3
		}), e.withLogging && (l.onConnected = () => console.info(`[WebSocket][${e.serviceName}] Connected`), l.onDisconnected = (t, n) => {
			console.info(`[WebSocket][${e.serviceName}] Disconnected.`, {
				reason: n.reason,
				event: n
			});
		}, l.onError = (t, n) => console.info(`[WebSocket][${e.serviceName}] Error: `, n), l.onMessage = (t, n) => {
			let r = n.data;
			if (r === "ping" || r === "pong") {
				console.info(`[WebSocket][${e.serviceName}] Heartbeat: ${r}`);
				return;
			}
			if (typeof r == "string" && /^[{[]/.test(r.trim())) {
				try {
					let t = JSON.parse(r);
					console.info(`[WebSocket][${e.serviceName}] Message:`, t);
				} catch (t) {
					console.warn(`[WebSocket][${e.serviceName}] Non‑JSON or malformed message ignored:`, r, t);
				}
				return;
			}
			console.info(`[WebSocket][${e.serviceName}] Message (text):`, r);
		}, typeof l.autoReconnect == "object" && (l.autoReconnect.onFailed = () => console.info(`[WebSocket][${e.serviceName}] Reconnection failed.`)));
		let { data: u, send: d, status: f, close: p } = r(`${c}?${t.toString()}`, l), m = i(null);
		a(u, (e) => {
			m.value = e;
		});
		let h = {
			status: f,
			data: m,
			send: d,
			close: p
		};
		o[e.serviceName] && o[e.serviceName].connection.close(), o[e.serviceName] = {
			connection: h,
			filter: n
		};
	}
	return o[e.serviceName].connection;
}, l = (t, n) => {
	let r = t.message ?? t.event;
	if (r) switch (r.case) {
		case e.SalesChannelStatusChanged:
			n.onSalesChannelStatusChanged?.(r.value);
			break;
	}
};
//#endregion
export { e as EventCaseName, n as EventService, t as EventSocketMessageAggregateType, l as matchEventServiceEvent, c as useEventService };
